import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useLoader } from '../api/useLoader';
import { PraksisstedApiContext } from '../api/PraksisstedApiContext';
import { useParams } from 'react-router-dom';
import Spinner from '../components/spinner/spinner';
import PageLayout from '../pagelayout';
import * as css from './userprofile.module.scss';
import { Grid } from '@mui/material';
import translations from './userprofile.i18n';

const StudentbrukerprofilPage: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { studiestedApi } = useContext(PraksisstedApiContext);
  const { id } = useParams<{ id: string }>();
  const { formatMessage } = useIntl();

  const { data } = useLoader(
    () =>
      studiestedApi.studentbrukerprofilIdGet({
        pathParams: { id: id as string },
      }),
    [id],
    true,
    true,
  );

  if (!data || !id) {
    return <Spinner />;
  }

  const labels = {
    title: formatMessage(
      { id: translations.titleStudent.id },
      { institusjon: data.bruker.studiestednavn },
    ),
    subtitle: formatMessage({ id: translations.subtitle.id }),
    tilbake: formatMessage({ id: translations.tilbake.id }),
    telefon: formatMessage({ id: translations.telefon.id }),
    epost: formatMessage({ id: translations.epost.id }),
  };

  const getInitials = (fornavn: string, etternavn: string) => {
    let initials = '';
    for (const name of `${fornavn} ${etternavn}`.split(/\s+/)) {
      initials += name[0];
    }
    return initials;
  };

  const initials = getInitials(data.bruker.fornavn, data.bruker.etternavn);

  return (
    <PageLayout isIndented title={labels.title} subtitle={labels.subtitle}>
      <div>
        <Grid container={true} className={css.container}>
          <Grid item={true} xs={3}>
            <div className={css.profilePictureReplacement} aria-hidden="true">
              {initials}
            </div>
          </Grid>
          <Grid item={true} xs={8}>
            <Grid container={true}>
              <Grid item={true} xs={12}>
                <span className={css.name}>
                  {data.bruker.fornavn + ' ' + data.bruker.etternavn}
                </span>
              </Grid>
              <Grid item={true} xs={12}>
                <Grid container={true}>
                  <Grid item={true} xs={4}>
                    <span>{data.bruker.studiestednavn}</span>
                  </Grid>
                  <Grid item={true} xs={4}>
                    <span>
                      <span className={css.label}>{labels.telefon}</span>{' '}
                      {data.bruker.telefonnummer}
                    </span>
                  </Grid>
                  <Grid item={true} xs={4}>
                    <span>
                      <span className={css.label}>{labels.epost}</span>{' '}
                      {data.bruker.epost}
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </PageLayout>
  );
};

export default StudentbrukerprofilPage;
